import { Pipe, PipeTransform } from "@angular/core";
@Pipe({
    name: "multilevelFilter"
})

// This pipe filters multilevel objects - objects with properties that are objects
// [league: 'West',{name: {first: 'John', last: 'Smith'}}
// It employs javascript 'dot' syntax eg name.first = 'John'
// It is built to unwind t three leves but could be easily expanded
export class MultiLevelFilter implements PipeTransform {
    transform<T extends object>(items: T[], filterProps: Array<string>, filterVal: string): T[] {
        if (filterVal && filterVal.length > 0) {
            const search = filterVal.toLowerCase();
            return items.filter(item => {
                for (const filterProp of filterProps) {
                    const props = filterProp.split(".");
                    if (props.length >= 1 && props.length <= 3) {
                        const val = getNestedValue(item, props);
                        if (typeof val === "string" && val.toLowerCase().indexOf(search) > -1) return true;
                    }
                }
                return false;
            });
        } else {
            return items;
        }
    }
}

function isRecord(value: unknown): value is Record<string, unknown> {
    return typeof value === "object" && value !== null;
}

function getNestedValue(obj: unknown, keys: string[]): unknown {
    let current: unknown = obj;
    for (const key of keys) {
        if (!isRecord(current)) return undefined;
        current = current[key];
    }
    return current;
}
